import { Component } from "excalibur";

export class VisibleComponent extends Component {}
